import { useEffect, useState } from 'react'
import { Preferences } from '@capacitor/preferences'
import Cookies from 'universal-cookie'
import Bugsnag from '@bugsnag/js'

export const TOKEN_NAME: string = 'authToken'

const cookies: Cookies = new Cookies()

async function setInStorage(key: string, value: string): Promise<void> {
    try {
        cookies.set(key, value, { path: '/' })
        await Preferences.set({ key, value })
    } catch (error) {
        Bugsnag.notify(`Error setting token, ${key} : ${error}`)
    }
}

async function getInStorage(key: string): Promise<string> {
    try {
        const { value }: { value: string | null } = await Preferences.get({ key })
        const cookie: string = cookies.get(key)
        return value || cookie || ''
    } catch (error) {
        Bugsnag.notify(`Error getting token, ${key} : ${error}`)
        return ''
    }
}

async function removeInStorage(key: string): Promise<void> {
    try {
        await Preferences.remove({ key })
        cookies.remove(key)
    } catch (error) {
        Bugsnag.notify(`Error deleting token, ${key} : ${error}`)
    }
}

function useAuthToken(): [string, boolean, (newAuthToken: string) => void, () => void] {
    const [authToken, setAuthToken] = useState<string>('')
    const [initialized, setInitialized] = useState<boolean>(false)

    useEffect(() => {
        const fetchToken: () => Promise<void> = async (): Promise<void> => {
            const token: string = await getInStorage(TOKEN_NAME)
            setAuthToken(token)
            setInitialized(true)
        }
        fetchToken()
    }, [])

    const setToken: (newAuthToken: string) => Promise<void> = async (newAuthToken: string): Promise<void> => {
        await setInStorage(TOKEN_NAME, newAuthToken)
        setAuthToken(newAuthToken)
    }

    const removeToken: () => Promise<void> = async (): Promise<void> => {
        await removeInStorage(TOKEN_NAME)
        setAuthToken('')
    }

    return [authToken, initialized, setToken, removeToken]
}

export { useAuthToken, setInStorage, getInStorage, removeInStorage }
